module.exports = __webpack_public_path__ + "static/media/BellNoNotificationIcon.922b376f.svg";